import {makeAutoObservable} from "mobx";
import {DayWeekState} from "../../shared/enums/eventDayWeekState";

export class DayWeekObservable {
  index: number;
  state: DayWeekState;
  label: string;
  fullLabel: string;

  constructor(
    index: number,
    state: DayWeekState,
    label: string,
    fullLabel: string = ""
  ) {
    makeAutoObservable(this);
    this.index = index;
    this.state = state;
    this.label = label;
    this.fullLabel = fullLabel;
  }
}
